import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "../ui/tooltip";

/**
 * Striscia compatta di etichette per l'header di un esercizio.
 * Le etichette non vanno mai a capo: quelle in eccesso vengono raccolte
 * in un chip "+N" con tooltip riepilogativo.
 */

const TONE_CLASSES = {
	volt: "bg-volt/10 border-volt/30 text-volt",
	amber: "bg-amber-500/10 border-amber-500/30 text-amber-300",
	emerald: "bg-emerald-500/10 border-emerald-500/30 text-emerald-300",
	muted: "bg-muted/40 border-border text-muted-foreground",
};

const BASE_CHIP_CLASSES =
	"inline-flex items-center gap-1 h-5 px-1.5 rounded-sm border text-[10px] uppercase tracking-wider leading-none whitespace-nowrap cursor-default";

function TagChip({ tag }) {
	const Icon = tag.icon;
	const chip = (
		<span
			className={`${BASE_CHIP_CLASSES} ${TONE_CLASSES[tag.tone] || TONE_CLASSES.muted}`}
		>
			{Icon && <Icon className="w-3 h-3 flex-shrink-0" />}
			{tag.showLabel && tag.label && (
				<span className={`${tag.labelWidthClass || "max-w-[92px]"} truncate`}>
					{tag.label}
				</span>
			)}
			{!tag.showLabel && tag.badgeValue != null && (
				<span className="font-mono">{tag.badgeValue}</span>
			)}
		</span>
	);

	const tooltip = tag.tooltip || tag.label;
	if (!tooltip) return chip;

	return (
		<Tooltip>
			<TooltipTrigger asChild>{chip}</TooltipTrigger>
			<TooltipContent
				side="top"
				className="max-w-xs"
			>
				{tooltip}
			</TooltipContent>
		</Tooltip>
	);
}

export function ExerciseTagStrip({ tags = [], maxVisible = 4, className = "" }) {
	const visibleTags = tags.filter(Boolean);
	if (visibleTags.length === 0) return null;

	const shown =
		visibleTags.length > maxVisible
			? visibleTags.slice(0, maxVisible - 1)
			: visibleTags;
	const hidden = visibleTags.slice(shown.length);

	return (
		<TooltipProvider delayDuration={90}>
			<div
				className={`flex items-center gap-1 flex-nowrap flex-shrink-0 ${className}`}
			>
				{shown.map((tag) => (
					<TagChip key={tag.key} tag={tag} />
				))}
				{hidden.length > 0 && (
					<Tooltip>
						<TooltipTrigger asChild>
							<span
								className={`${BASE_CHIP_CLASSES} ${TONE_CLASSES.muted}`}
							>
								+{hidden.length}
							</span>
						</TooltipTrigger>
						<TooltipContent
							side="top"
							className="max-w-xs"
						>
							<div className="space-y-1">
								{hidden.map((tag) => (
									<p key={tag.key}>{tag.label}</p>
								))}
							</div>
						</TooltipContent>
					</Tooltip>
				)}
			</div>
		</TooltipProvider>
	);
}

export default ExerciseTagStrip;
